import {Injectable} from '@angular/core';
import {Observable, throwError} from 'rxjs';
import {HttpClient, HttpErrorResponse} from '@angular/common/http';
import {catchError} from 'rxjs/operators';
import {TaxplanIQServices} from "../services/TaxplanIQServices";
import {SOURCE_TYPE} from "../constants/Tpiq.constants";

export function getAllPlansDataUrl(org, userId, type?) {
  let link = `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules`;
  if (type) {
    link += `?type=${type}`;
  }
  return link;
}

export function createOrEditPlanUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules`;
}

export function getRemovePlanUrl(org, userId, planId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/${planId}`;
}

export function getAdditionalResourcesUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/resources`;
}

export function getRemoveResourceUrl(org, userId, resourceId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/resource/${resourceId}`;
}

export function getOneOnOneUrl(org, userId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/one-on-one`;
}
export function getCategoryList(org, userId){
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/categories`;
}

export function createEmailTemplate(org, userId){
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/growthPlanEmailTemplate`;
}

export function getEmailTemplateList(org,userId, audience){
   let link = `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/growthPlanEmailTemplates`;

  if (audience) {
    link += `?audience=${audience}`;
  }
  return link;
}

export function getRemoveEmailTemplate(org, userId, templateId) {
  return `/TaxPlanningServices/org/${org}/users/${userId}/growthplanschedules/emailTemplate/${templateId}`;
}

@Injectable({
  providedIn: 'root'
})
export class GrowthPlanService extends  TaxplanIQServices {

  options = {};
  constructor(http: HttpClient) {
    super(http);
  }

  createOrEditPlan(org, userId, obj): Observable<any> {
    const url = createOrEditPlanUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removePlan(org, userId, eventId): Observable<any> {
    const url = getRemovePlanUrl(org, userId, eventId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAllPlans(org, userId, type?): Observable<any> {
    const url = getAllPlansDataUrl(org, userId, type);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getAdditionalResources(org, userId): Observable<any> {
    const url = getAdditionalResourcesUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createOrEditPlanResource(org, userId, obj): Observable<any> {
    const url = getAdditionalResourcesUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  removePlanResource(org, userId, resourceId): Observable<any> {
    const url = getRemoveResourceUrl(org, userId, resourceId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  updateOneOnOneEvent(org, userId, obj): Observable<any> {
    const url = getOneOnOneUrl(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getOneOnOneEvent(org, userId): Observable<any> {
    const url = getOneOnOneUrl(org, userId);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getCategoryList(org, userId) : Observable<any> {
     const url = getCategoryList(org, userId);
     return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  createEmailTemplate(org, userId, obj) : Observable<any> {
    const url = createEmailTemplate(org, userId);
    return this.create(url, obj, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getEmailTemplateList(org, userId, audience) : Observable<any> {
    const url = getEmailTemplateList(org, userId, audience);
    return this.query(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  getRemoveEmailTemplate(org, userId, templateId) : Observable<any> {
    const url = getRemoveEmailTemplate(org, userId, templateId);
    return this.delete(url, SOURCE_TYPE.JAVA).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse): any {
    return throwError(error.error);
  }

}
